import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import Header from 'src/conponents/Shared/Header';

function GuestLayout({ children }) {
  return (
    <div className="guest-layout">
      <Header />
      {children}
    </div>
  );
}

GuestLayout.propTypes = {
  children: PropTypes.element,
};

export default GuestLayout;
